module.exports = __webpack_public_path__ + "img/TierTwoFindings_01A.ae18d702.jpg";